/** 
 * [agentSource 获取上报source场景值]
 * @class agentSource
 */

const sourceMap = {
    // 分期乐APP-android
    '1000004': /fenqile_android_(\d+\.\d+\.\d+)/i,
    // 分期乐APP-ios
    '1000005': /fenqile_ios_(\d+\.\d+\.\d+)/i,
    // 分期乐SDK-android
    '1000006': /fenqile_paysdk_android_(\d+\.\d+\.\d+)/i,
    // 分期乐SDK-ios
    '1000007': /fenqile_paysdk_ios_(\d+\.\d+\.\d+)/i,
    // 乐卡APP-android
    '2000003': /leka_android_(\d+\.\d+\.\d+)/i,
    // 乐卡APP-ios
    '2000004': /leka_ios_(\d+\.\d+\.\d+)/i,
    // 采蛋APP-android
    '3000003': /tiqianle_fenqile_android_(\d+\.\d+\.\d+)/i,
    // 采蛋APP-ios
    '3000004': /tiqianle_fenqile_ios_(\d+\.\d+\.\d+)/i,
    // 新版提钱乐APP-android
    '4000003': /mac4me_fenqile_android_(\d+\.\d+\.\d+)/i,
    // 新版提钱乐APP-ios
    '4000004': /mac4me_fenqile_ios_(\d+\.\d+\.\d+)/i
};

const AgentSource = {
    getReportSource() {
        let ua = navigator.userAgent;
        let sceneSource = '1000002';  // 默认为分期乐H5的场景值

        for (let i in sourceMap) {
            if (sourceMap[i].test(ua)) {
                return i;
            }
        }
        
        return sceneSource;
    }
};

// 对外提供接口
export default AgentSource;